import classnames from "classnames";
import React, {
  Component,
  createRef,
  useRef,
  useLayoutEffect,
  useEffect,
  useState,
} from "react";
import _ from "underscore";
import ReactDOM from "react-dom";
import { GeneEditSequenceSpanElement } from "./GEComponents";

/**
 * GeneEditSliderComponent
 * - Gene Edit Slider for gene snippet selection.
 * @param {[type]} props [description]
 */
export const GeneEditSequenceDisplay = (props) => {
  // Convert it to functional component to create refs
  const divRef = useRef();
  const [width, setWidth] = useState(0);
  const [height, setHeight] = useState(0);
  const [left, setLeft] = useState(0);

  const updateDivDimensions = () => {
    setWidth(divRef.current.clientWidth);
    setHeight(divRef.current.clientHeight);
    setLeft(divRef.current.clientLeft);
  };

  useEffect(() => {
    if (divRef.current) {
      setWidth(divRef.current.clientWidth);
      setHeight(divRef.current.clientHeight);
      setLeft(divRef.current.clientLeft);
    }

    window.addEventListener("resize", updateDivDimensions);

    if (props.sendBackState) {
      props.sendBackState({ width: width, height: height, left: height });
    }

    return () => {
      window.removeEventListener("resize", updateDivDimensions);
    };
  }, [divRef.current, width, height]);

  const {
    sequenceList,
    classes,
    sendSpanDimensions,
    selectionPoints,
    translationPoints,
  } = props;
  const selected =
    (!_.isEmpty(classes) &&
      !_.isNull(classes) &&
      !_.isEmpty(classes.selected) &&
      classes.selected) ||
    "";

  const geneElement =
    (!_.isEmpty(classes) &&
      !_.isNull(classes) &&
      !_.isEmpty(classes.geneElement) &&
      classes.geneElement) ||
    "";

  const isIndexSelected = (index) =>
    (index === selectionPoints[0] || index > selectionPoints[0]) &&
    index < selectionPoints[1];

  return (
    <div
      ref={divRef}
      className={classnames("d-flex", "flex-wrap", classes.spanContainer)}
    >
      {_.map(sequenceList, (gene, index) => {
        return (
          <GeneEditSequenceSpanElement
            index={index}
            key={index}
            selected={(isIndexSelected(index) && selected) || ""}
            geneElement={geneElement}
            gene={gene}
            sendSpanDimensions={sendSpanDimensions}
          />
        );
      })}
    </div>
  );
};
